import React, { useEffect } from "react"
import ReactPlayer from 'react-player'
import { Box, useMediaQuery, useTheme } from "@material-ui/core"
import clsx from 'clsx'

import playCircleFill from '~/images/icons/play-circle-fill.svg'

import styles from './styles'

interface IVideoPlayerProps {
    // Video url
    url: string
    preview?: string
    className?: string
}

export const VideoPlayer = ({ url, className, preview }: IVideoPlayerProps) => {
    const classes = styles()
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.down('lg'));
    const isLaptop = useMediaQuery(theme.breakpoints.down('md'));
    const isTablet = useMediaQuery(theme.breakpoints.down('sm'));
    const isMobile = useMediaQuery(theme.breakpoints.down('xs'));
    const getSize = () => {
      if(isMobile) return {
        height: 216,
        width: 375
      };
      if(isTablet) return {
        height: 432,
        width: 768
      };
      if(isLaptop) return {
        height: 403,
        width: 944
      };
      if(isDesktop) return {
        height: 560,
        width: 1248
      };
    };
    return (
        <Box className={clsx(classes.wrapper, className)}>
            <ReactPlayer
                controls
                playing={true}
                light={preview}
                style={{ height: 200 }}
                url={url}
                playIcon={
                    <img src={playCircleFill} className={classes.playIcon} alt="playIcon" />
                }
                config={{
                  vimeo: {
                    playerOptions:{
                      ...getSize(),
                      allowFullScreen: false
                    }
                  }
                }}
                width="100%"
                height="100%"
            />
        </Box>
    )
}
